import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import BackButton from '../components/backButton'
import Footer from '../components/footer'
import Loading from '../components/loading'
import NavBar from '../components/navbar'
import checkCircle from '../images/check-circle-fill.svg'
import dashCircle from '../images/dash.png'
import nbLogo from '../images/New_Brunswick_Canada_Logo_Watermark.svg'

import { getVaccinationStatus, setErrorState } from '../actions/api'

import * as settings from '../globals/settings'
import { formatDateOfBirth2, getToday } from '../util/util'

class VaccinePassportScreen extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            user: props.user,
            sendLoginAlert: false,
        }
    }

    componentDidMount() {
        if (settings.DEBUG === "true") {
            return
        }
        this.state.user = this.props.location.user
        this.getVaccinationStatus()

    }

    getVaccinationStatus() {
        try {
            let userId = null
            if (this.state.user.isDependent) {
                userId = this.state.user.id
            }
            this.props.dispatch(getVaccinationStatus(userId))
        } catch(err) {
            if (err !== null && err !== undefined) {
                if(err.code === 'ARE' || err.code === 'ADE') {
                    this.setState({sendLoginAlert: true})
                } else if (err.code === 'SIE' || err.code === 'MIE' || err.code === 'LREE' || err.code === 'DAE' || err.code === 'PVE') {
                    this.props.dispatch(setErrorState(true, err.message, true))
                } else {
                    this.props.history.push("/")
                }
            }
        }
    }

    renderBackButton() {
        let prevPage = this.props.location.state.prevPath
        if (prevPage === "/immunizations") {
            return <BackButton target={"/immunizations"} buttonText={this.props.strings.BACK_TEXT}/>
        }
        else {
            return <BackButton buttonText={this.props.strings.BACK_TEXT}/>
        }
    }

    renderVaccinatedBox() {
        let vaccinationStatus = null
        if (this.props.vaccinationStatus === 'FULL') {
            vaccinationStatus = true
        }
        else {
            vaccinationStatus = false
        }

        if (vaccinationStatus === true) {
            return (
                <div className="passport-container-white">
                    <div className="col-smaller col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto green-watermark-mobile">
                        <p className="passport-header-mobile text-center font-weight-bold">{this.props.strings.VACCINE_PASSPORT_HEADER}</p>
                        <div className="divider-mobile mx-auto"></div>
                        <h3 className="text-center mt-3 font-weight-bold text-uppercase">{this.state.user.firstName + " " + this.state.user.lastName}</h3>
                        <h6 className="passport-dob-mobile text-center font-weight-bold">{this.props.strings.VACCINE_PASSPORT_DOB}{formatDateOfBirth2(this.state.user.dateOfBirth, this.props.language)}</h6>
                    </div>
                    <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5 green-box-mobile mx-auto d-flex flex-column align-items-center col-smaller">
                        <div className="green-box-content mx-auto">
                            <img className="check-icon mx-auto d-block" src={checkCircle} width="120px"/>
                            <h3 className="text-center font-weight-bold text-white mt-3">{this.props.strings.VACCINATION_STATUS}</h3>
                            <p className="text-center text-white font-weight-bold my-0 ">{this.props.strings.VACCINATED_TEXT_ISSUED}{getToday(this.props.language)}</p>
                        </div>
                        <img className="nb-logo-img" src={nbLogo} width="140px" />
                    </div>
                </div>
            )
        }
        else if (vaccinationStatus === false) {
            return (
                <div className="passport-container-white">
                    <div className="col-smaller col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto red-watermark-mobile">
                        <p className="passport-header-mobile text-center font-weight-bold">{this.props.strings.VACCINE_PASSPORT_HEADER}</p>
                        <div className="divider-mobile mx-auto"></div>
                        <h3 className="text-center mt-3 font-weight-bold text-uppercase">{this.state.user.firstName + " " + this.state.user.lastName}</h3>
                        <h6 className="passport-dob-mobile text-center font-weight-bold">{this.props.strings.VACCINE_PASSPORT_DOB}{formatDateOfBirth2(this.state.user.dateOfBirth, this.props.language)}</h6>
                    </div>
                    <div className="col-smaller col-sm-10 col-md-8 col-lg-6 col-xl-5 red-box-mobile mx-auto d-flex flex-column align-items-center">
                        <div className="red-box-content mx-auto">
                            <img className="x-icon mx-auto d-block" src={dashCircle} width="120px"/>
                            <h3 className="text-center font-weight-bold mt-3">{this.props.strings.VACCINATION_STATUS_NA}</h3>
                            <p className="text-left font-weight-bold mb-0 pt-2 px-3">{this.props.strings.VACCINATION_X_NOTE_1}</p>
                            <p className="text-left font-weight-bold pt-3 px-3">{this.props.strings.VACCINATION_X_NOTE_2}</p>
                        </div>
                        <img className="nb-logo-img" src={nbLogo} width="140px" />
                    </div>
                </div>
            )
        }
    }

    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        }

        // FIXME Remove fake login!!!
        if ((this.props.isLoggedIn !== true && this.props.isFakeLoggedIn !== true) || this.state.sendLoginAlert) {
            return <Redirect to={{
                pathname: "/",
                state: { loginAlert: this.state.sendLoginAlert }
            }}/>
        }

        if (this.props.isLoadingVaccinationStatus === true) {
            return <Loading />
        }

        return (
            <>
                <NavBar isLoggedIn={this.props.isLoggedIn} language={this.props.language} />
                <div className="container">
                    <div className="row">
                        <div className="col-10">
                            {this.renderBackButton()}
                        </div>
                    </div>
                    {this.renderVaccinatedBox()}
                </div>
                <Footer />
            </>
        )

    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.api.user,
        strings: state.language.strings,
        language: state.language.language,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        selectedUser: state.api.selectedUser,
        isError: state.api.isError,
        deviceType: state.api.deviceType,
        isLoadingVaccinationStatus: state.api.isLoadingVaccinationStatus,
        vaccinationStatus: state.api.vaccinationStatus,
    }
}

const ConnectedPassportScreen = connect(
    mapStateToProps
)(VaccinePassportScreen);
export default ConnectedPassportScreen;